import React, { useState } from 'react';
import scanIcon from '../../styles/img/Scan_icon.svg';
import PrimaryButton from './PrimaryButton';
import useAxios
 from '../../axios/useAxios';
import { notifyWarning } from '../../utils/Notify';
import { isAppPWA } from '../../utils/helper-functions';

const ScanButton = ({ onClick, label, store, editSelectedStore, disabled }) => {
  const handleClick = () => {
    if (!store || !store.id) {
      editSelectedStore();
      return;
    }
    onClick();
  };

  return (
    <PrimaryButton
      onClick={handleClick}
      label={label}
      icon={disabled ? null : scanIcon}
      disabled={disabled}
    />
  );
};

export default ScanButton;
